import { Typography } from "@material-ui/core";
import moment from "moment";
import {
  ResourceContextProvider,
  Datagrid,
  TextField,
  FunctionField,
  ReferenceField,
  Filter,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import React from "react";
import UpdatedByField from "components/UpdatedByField";
import { PaddingDenseStyledList } from "../../../components/ListWrapper";
import CustomPagination from "../../../components/CustomPagination";

const NotTakingStudentTable = () => {
  const NotTakingFilter = (props: any) => {
    return (
      <Filter {...props}>
        <ReferenceInput
          source="BusScheduleId"
          label="Wave Name"
          filter={{
            SchoolId: Number(SchoolIdSelected()),
          }}
          reference="busSchedules"
          alwaysOn
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      </Filter>
    );
  };

  return (
    <ResourceContextProvider value="notTakingStudents">
      <PaddingDenseStyledList
        basePath="/notTakingStudents"
        actions={null}
        exporter={false}
        hasCreate={false}
        filters={<NotTakingFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        sort={{ field: "updatedAt", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
        pagination={<CustomPagination />}
      >
        <Datagrid>
          <ReferenceField
            label="Student"
            source="studentId"
            reference="students"
            link={false}
          >
            <FunctionField
              render={(record: any) => `${record.firstName} ${record.lastName}`}
            />
          </ReferenceField>
          <ReferenceField
            label="Wave Name"
            source="busSchedulePlanId"
            reference="busSchedulePlans"
            link={false}
          >
            <ReferenceField
              source="busScheduleId"
              reference="busSchedules"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>
          <ReferenceField
            label="Route"
            source="routeId"
            reference="routes"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <FunctionField
            label="Not Taking by Days"
            render={(record: any) => {
              let days: string = "";

              if (record.period === null) {
                if (record.isMonday) {
                  days = days + " Monday,";
                }
                if (record.isTuesday) {
                  days = days + " Tuesday,";
                }
                if (record.isWednesday) {
                  days = days + " Wednesday,";
                }
                if (record.isThursday) {
                  days = days + " Thursday,";
                }
                if (record.isFriday) {
                  days = days + " Friday,";
                }
                if (record.isSaturday) {
                  days = days + " Saturday,";
                }
                if (record.isSunday) {
                  days = days + " Sunday,";
                }

                return days.replace(/,(?=[^,]*$)/, "");
              } else {
                return "-";
              }
            }}
          />
          <FunctionField
            label="Not Taking by Dates"
            render={(record: any) => {
              const format = "DD / MM / YYYY";
              return (
                <>
                  <Typography variant="body2">
                    {record.period === null
                      ? `-`
                      : `${moment
                          .utc(record.period?.start)
                          .format(format)} - ${moment
                          .utc(record.period?.end)
                          .format(format)}`}
                  </Typography>
                </>
              );
            }}
          />
          <FunctionField
            label="Updated By"
            render={(record: any) => (
              <>
                {record.updatedBy === null ? (
                  "-"
                ) : (
                  <UpdatedByField data={record.updatedBy} />
                )}
              </>
            )}
          />
        </Datagrid>
      </PaddingDenseStyledList>
    </ResourceContextProvider>
  );
};

export default NotTakingStudentTable;
